import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { UserService } from 'app/core/services/user.service';
import { NotifMessageService } from 'app/core/services/notifmessage.service';
import { Subscription, forkJoin, from } from 'rxjs';
import { User } from 'app/core/models/user';
import { AuthenticatedRouteGuard } from 'security/authenticatedRouteGuard.service';
import { NgbdSortableHeader, SortEvent, compare } from 'app/core/directives/sortable.directive';
import { PaginationService } from 'app/core/services/pagination.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DELETE_ICON, DETAILS_ICON, EDIT_ICON } from 'app/table-pages/table-utils/custom-svgs/custom-svgs';

@Component({
  selector: 'app-users-page',
  templateUrl: './users-page.component.html',
  styleUrls: ['./users-page.component.css']
})
export class UsersPageComponent implements OnInit {

  users: Array<User> = new Array<User>();
  usersInit: Array<User> = new Array<User>();
  isLoading: boolean = true;
  criteria: {} = [];
  page: number =1;
  pageSize: number =  this.paginationService.pageSizeItems[0];
  pager: {
    sortBy: string;
    order: string;
    first: number;
    max: number;
  };
  modalResponseSubscription: Subscription;
  searchSub: Subscription;
  sub: Subscription;
  columnsToDisplay = ['username', 'firstName','lastName','actions'];

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private userService: UserService,
    private notifService: NotifMessageService,
    private roleGuard: AuthenticatedRouteGuard,
    private paginationService: PaginationService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIconLiteral('EDIT', sanitizer.bypassSecurityTrustHtml(EDIT_ICON));
    iconRegistry.addSvgIconLiteral('DETAILS', sanitizer.bypassSecurityTrustHtml(DETAILS_ICON));
    iconRegistry.addSvgIconLiteral('DELETE', sanitizer.bypassSecurityTrustHtml(DELETE_ICON));
   }

  ngOnInit() {
    this.pager = {
      sortBy: "username",
      order: "asc",
      first: this.page - 1,
      max: this.pageSize
    }
    this.getUsers();
    this.searchSub = this.userService.criteriaSubject.subscribe(criteria => {
      this.criteria = criteria;
      this.first();
    });
    this.sub = this.userService.userSubject.subscribe(users => {
      this.users = users;
    });
  }

  ngOnDestroy(): void {
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  getUsers(): void {
    this.isLoading = true;
    this.userService.getUsers(this.pager).subscribe(
      users => {
        this.users = users;
        if (this.users && this.users.length == 0) {
          this.notifService.notifyInfo('EMPTY_RESULT');
        }
        this.initHeaders("username", "ASC");
        this.isLoading = false;

      });
  }

  deleteUser(user) {
    this.notifService.emitModalWithDetails("DELETE_USER", [user.username,"USER_DELETION","DELETE_USER"]);

    this.modalResponseSubscription = this.notifService.modalResponseSubject.subscribe(resp => {
      if (resp) {
        this.userService.deleteUser(user.id).subscribe(
          res => {
            if (res != "error") { // "error" because the function on success return null
              this.getUsers();
              this.notifService.notifySuccess('USER_DELETED');
              this.modalResponseSubscription.unsubscribe();
            }
          }
        );
      } else {
        this.modalResponseSubscription.unsubscribe();
      }
    });
  }

  details(user) {
    this.notifService.emitModalWithDetails("USER", user);
  }

  onPageChange() {
    this.pager["page"] = this.page;
    this.pager["max"] = this.pageSize;
    this.paginationService.pageChange("user", this.criteria, this.pager);
  }

  onRowsPerPageChange(){
    this.page = 1;
    this.pager["page"] = this.page;
    this.pager["max"] = this.pageSize;
    this.paginationService.pageChange("user", this.criteria, this.pager);
  }

  initHeaders(column, direction) {
    this.headers.forEach(header => {
      if (header.sortable === column) {
        header.direction = direction;
      }
    });
  }

  onSort({ column, direction }: SortEvent) {
    this.pager["page"] = this.page;
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction === '') {
      this.onPageChange();
    } else {
      this.pager["sortBy"] = column;
      this.pager["order"] = direction.toLowerCase();
      this.paginationService.pageChange("user", this.criteria, this.pager);
    }
  }

  first() {
    this.page = 1;
    this.onPageChange();
  }

  prev() {
    this.page -= 1;
    this.onPageChange();
  }

  next() {
    this.page += 1;
    this.onPageChange();
  }
}
